import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{attrs:{"outlined":!_vm.selected,"color":"var(--agora)","text-color":_vm.selected ? 'white' : '',"close":"","close-icon":_vm.icon},on:{"click":_vm.clicked}},[_vm._v(_vm._s(_vm.tag.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }